$(document).ready(function () {
  $(document).on("click", ".trigger_popup_fricc1", function () {
    console.log("click");
    $(".hover_bkgr_fricc1").show();
  });

  $(document).on("click", ".hover_bkgr_fricc1", function () {
    $(".hover_bkgr_fricc1").hide();
  });

  $(document).on("click", ".popupCloseButton1", function () {
    $(".hover_bkgr_fricc1").hide();
  });

  var custom_ship = $(".custom-ship-text").attr("data-ship");
  console.log("custom_ship---------------------", custom_ship);
  setTimeout(function () {
    if (
      $("buy-buttons .button").text().trim().toLowerCase() === "add to cart"
    ) {
      $(".custom-ship-text").text(custom_ship);
    }
  }, 2000);
});
